module.exports = __webpack_public_path__ + "h5/static/img/cyberchain-logo.8ce41398.png";